export default "__VITE_ASSET__B8NEFI95__"